import {FormControl, MenuItem, TextField} from "@material-ui/core";
import React from "react";

const InputComboBox = (props) => {
    const {
        value,
        field,
        label,
        handleOnChange,
        options,
        errorMessage,
        required,
        menuClass,
        multiple,
        disabled,
        disablePortal,
    } = props;

    return (
        <FormControl fullWidth>
            <TextField
                select
                fullWidth
                required={required}
                variant='outlined'
                value={value}
                label={label}
                name={field}
                disabled={disabled || false}
                onChange={handleOnChange}
                error={props.error}
                SelectProps={{
                    MenuProps: {
                        className: menuClass,
                        disablePortal: disablePortal
                    },
                    multiple: multiple
                }}
            >
                <MenuItem value="">
                    <em>Chose an Option</em>
                </MenuItem>
                {
                    options.map((item) => <MenuItem key={`${field}}-${item.id}`} value={item.id}>{item.name}</MenuItem>)
                }
            </TextField>
            <span>{errorMessage}</span>
        </FormControl>
    )
}

export default InputComboBox;